import { useNavigate, Link } from "react-router-dom";
import { ChevronRight, LogOut } from "lucide-react";
import { API, apiFetch } from "@/utils/api";

const SECTIONS = [
  { to: "/conciliacion", label: "Conciliación" },
  { to: "/clientes", label: "Clientes" },
  { to: "/suscripciones", label: "Suscripciones" },
  { to: "/presupuestos", label: "Presupuestos" },
  { to: "/alertas", label: "Alertas" },
  { to: "/informes", label: "Informes" },
  { to: "/documentos", label: "Documentos" },
  { to: "/banco/reglas", label: "Reglas del banco" },
  { to: "/contabilidad/plan", label: "Plan de cuentas" },
  { to: "/contabilidad/diario", label: "Libro diario" },
  { to: "/exportar", label: "Exportar · Gestoría" },
  { to: "/ajustes", label: "Ajustes" },
];

export default function MobileMore() {
  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      await apiFetch(`${API}/auth/logout`, { method: "POST" });
    } finally {
      navigate("/login");
    }
  };
  return (
    <div data-testid="mobile-more">
      <h1 className="font-heading text-2xl font-bold text-slate-900">Más</h1>
      <p className="mt-1 text-sm text-slate-500">El resto de secciones, en modo consulta.</p>
      <div className="mt-4 bg-white border border-slate-200 rounded-2xl overflow-hidden divide-y divide-slate-100">
        {SECTIONS.map((s) => (
          <Link
            key={s.to}
            to={s.to}
            className="flex items-center justify-between px-4 min-h-[48px] text-sm text-slate-900 hover:bg-slate-50"
          >
            {s.label}
            <ChevronRight className="w-4 h-4 text-slate-400" strokeWidth={1.5} />
          </Link>
        ))}
      </div>
      <button
        onClick={handleLogout}
        className="mt-4 w-full min-h-[48px] rounded-2xl border border-slate-200 bg-white text-sm font-medium text-red-600 flex items-center justify-center gap-2"
      >
        <LogOut className="w-4 h-4" strokeWidth={1.5} /> Cerrar sesión
      </button>
    </div>
  );
}
